import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export const GIVFBanner = () => {
  const navigate = useNavigate();
  return (
    <motion.div
      className="sticky top-0 z-50 bg-gradient-to-r from-yellow-400 via-pink-400 to-pink-600 text-white py-3"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", stiffness: 100, damping: 20 }}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center gap-4 flex-wrap sm:flex-nowrap">
          <span className="font-semibold text-base md:text-lg">
            GREAT INDIAN VOLUNTEERING FESTIVAL – India’s Biggest Volunteering
            Movement | June 5 – Sept 5, 2025
          </span>
          <Button
            onClick={() =>
              navigate("/events/great-india-volunteering-festival-tgivf-2025")
            }
            variant="outline"
            className="bg-white text-pink-600 hover:bg-white/90 font-medium whitespace-nowrap border-none shadow-md"
            size="sm"
          >
            Learn More →
          </Button>
        </div>
      </div>
    </motion.div>
  );
};
